var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"color":"white","text-align":"center"}},[_c('h1',[_vm._v("Espere por favor")]),_c('h3',[_vm._v("CARGANDO...")])])
}]

export { render, staticRenderFns }